export enum SupportedCountry {
  Germany = 'de',
  Portugal = 'pt',
  Italy = 'it',
}
